import { type MultiLessonFlags } from "#/components/exam-results/types";
import { type SingleStudentExamResult } from "#/services/rest/gwt/exam-results/views/type-2/single-user.types";
import { useMemo } from "react";
import MultiLessonCard from "./Card";
import styles from "./styles.module.scss";

type MultiLessonCardProps = {
  participantNo: number;
  data: SingleStudentExamResult[];
};

const MultiLessonCards = ({ data, participantNo }: MultiLessonCardProps) => {
  const flags = useMemo<MultiLessonFlags>(
    () => ({
      isMulti: participantNo > 1,
      hasTithe: participantNo >= 50,
    }),
    [participantNo],
  );

  return (
    <div className={styles["multiLessonCards"]}>
      {data.map((card) => (
        <MultiLessonCard key={card.itemName} flags={flags} {...card} />
      ))}
    </div>
  );
};

export default MultiLessonCards;
